/* eslint-disable prettier/prettier */
import axios from "axios";
import env from "../stores/modules/envdetect";
import store from "../stores/store";

// Default referring to a laracast about cors
axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

const apiClient = axios.create();

export default {
    generatePolicyDocument(viergewinnt) {
        return apiClient.post(
            "https://4gpdf.cleverads.de/api/generatePolicyDocument",
            { viergewinnt: viergewinnt },
            {
                responseType: "arraybuffer",
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/pdf"
                }
            }
        );
    },

    useSpecialSendService() {
        let url =
            "https://4gpdf.cleverads.de/api/VierGewinntMiddleTier/rest/callVierGewinntMiddleTierSendService";
        let viergewinnt = store.getters["work/getExportDataForSendService"];
        return apiClient.post(url, viergewinnt, {
            headers: {
                "Content-Type": "application/json"
            }
        });
    }
};
